<label class="ds-checkbox-wrapper">
    <input
        #checkbox
        type="checkbox"
        [attr.id]="id() || null"
        [attr.name]="name()"
        [attr.checked]="checked() ? '' : null"
        [attr.disabled]="disabled() ? '' : null"
        [attr.aria-checked]="indeterminate() ? 'mixed' : null"
        [attr.aria-label]="ariaLabel() || null"
        [attr.aria-labelledby]="ariaLabelledby() || null"
        [attr.aria-describedby]="ariaDescribedby() || null"
        [class.is-checked]="checked()"
        (blur)="onTouched()" />
    <div class="ds-checkbox-checkmark-wrapper">
        <div class="ds-checkbox-checkmark">
            @if (checked() && !indeterminate()) {
                <svg
                    aria-hidden="true"
                    fill="currentColor"
                    class="ds-checkbox-checkmark-icon ds-checkbox-checked"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 12 12">
                    <path fill="currentColor" fill-rule="evenodd" d="m12 2.65-7.63 7.63L0 5.9l.92-.92 3.45 3.45 6.71-6.71.92.92Z" />
                </svg>
            } @else if (indeterminate()) {
                <svg
                    aria-hidden="true"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ds-checkbox-checkmark-icon ds-checkbox-indeterminate"
                    viewBox="0 0 12 12">
                    <path fill-rule="evenodd" d="M11.4 6.6H.6C.27 6.6 0 6.33 0 6s.27-.6.6-.6h10.8c.33 0 .6.27.6.6s-.27.6-.6.6Z" />
                </svg>
            }
        </div>
    </div>
    <div class="ds-checkbox-text-wrapper">
        <span class="ds-checkbox-label-text">
            <ng-content />
        </span>
    </div>
</label>
